import { render } from "./ListArticlesOverview.vue?vue&type=template&id=0c71e8a4"
import script from "./ListArticlesOverview.vue?vue&type=script&lang=js"
export * from "./ListArticlesOverview.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__